import type { ActionCodeSettings } from 'firebase/auth';
import Constants from 'expo-constants';

const DEFAULT_PROD_APP_ORIGIN = 'https://app.tripvio.app';

function readExpoExtraValue(key: string): string | undefined {
  const constants = Constants as any;
  const candidates = [
    Constants.expoConfig?.extra,
    constants?.expoConfig?.extra,
    constants?.manifest?.extra,
    constants?.manifest2?.extra?.expoClient?.extra,
    constants?.manifest2?.extra,
  ];

  for (const extra of candidates) {
    const value = extra?.[key];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return undefined;
}

/**
 * Public URL where users should land in the web app after completing email verification
 * (Firebase continue URL / ActionCodeSettings.url). Must be on an Auth authorized domain.
 */
function webAppOrigin(): string {
  const configuredOrigin =
    process.env.EXPO_PUBLIC_WEB_APP_URL?.trim() ||
    readExpoExtraValue('EXPO_PUBLIC_WEB_APP_URL') ||
    DEFAULT_PROD_APP_ORIGIN;

  return configuredOrigin.replace(/\/$/, '');
}

export const EMAIL_VERIFIED_PATH = '/auth/email-verified';

export function getEmailVerifiedContinueUrl(): string {
  return `${webAppOrigin()}${EMAIL_VERIFIED_PATH}`;
}

/** Passed to `sendEmailVerification` so the verification email's redirect matches the web app. */
export function getEmailVerificationActionCodeSettings(): ActionCodeSettings {
  return {
    url: getEmailVerifiedContinueUrl(),
    handleCodeInApp: false,
  };
}
